<template lang="pug">
.instruction
  treatment-instruction-dropdown(v-if="item.editable && item.productItem.medication" :item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed', $event)")
  div.clickable(v-else-if="!item.editable && item.productItem.medication && item.productItem.medication.instruction")
    span.font-medium.danger500--text(v-if="item.error") {{ item.productItem.medication.instruction }}
    span(v-else) {{ item.productItem.medication.instruction }}
</template>

<script>
import TreatmentInstructionDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentInstructionDropdown.vue'

export default {
  components: {
    TreatmentInstructionDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>